module.exports = __webpack_public_path__ + "img/swiper-cargo.beee5039.png";